export default {"src":"/_next/static/media/search-not-found-white.d555f1dd.svg","height":41,"width":41,"blurWidth":0,"blurHeight":0};